import React from "react";
import { createRoot } from "react-dom/client";
import { ConfigCatProvider } from "configcat-react";
import { Provider } from "react-redux";
import "styles/global-styles.scss";
import { store } from "utils/redux/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { CONFIG_CAT_APP_KEY } from "utils/environmentVariables";
import { initSentry } from "utils/sentry";
import * as Sentry from "@sentry/react";

// Initialize Sentry as early as possible
initSentry();

const container = document.getElementById("root")!;
const root = createRoot(container);

// Strict mode is commented out because when working in strict mode, the plugins for chart js do not work locally.
// REMEMBER: Uncomment this when pushing to production.
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <Provider store={store}>
        <BrowserRouter>
          {CONFIG_CAT_APP_KEY ? (
            <ConfigCatProvider sdkKey={CONFIG_CAT_APP_KEY} pollingMode={2}>
              <App />
            </ConfigCatProvider>
          ) : (
            <App />
          )}
        </BrowserRouter>
      </Provider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
